<template>
  <div class="container login-form-container clearfix">
    <ul class="nav nav-pills nav-justified" id="myTab" role="tablist">
      <li :class="navClassFiscalData" role="presentation">
        <button
          :class="tabClass('fiscalData')"
          id="fiscal-tab"
          data-bs-toggle="pill"
          data-bs-target="#fiscal"
          type="button"
          aria-controls="fiscal"
          aria-selected="true"
          @click.prevent="toggleTab('fiscalData')"
        >
          <span v-if="isMobile == 0 || activeTab('fiscalData')">{{
            transPeralbaPro.item839
          }}</span>
          <span v-else>{{ transPeralbaPro.item840 }}</span>
        </button>
      </li>
      <li :class="navClassComercialData" role="presentation">
        <button
          :class="tabClass('comercialData')"
          id="comercial-tab"
          data-bs-toggle="pill"
          data-bs-target="#comercial"
          type="button"
          aria-controls="comercial"
          aria-selected="false"
          @click.prevent="toggleTab('comercialData')"
        >
          <span v-if="isMobile == 0 || activeTab('comercialData')">{{
            transPeralbaPro.item841
          }}</span>
          <span v-else>{{ transPeralbaPro.item842 }}</span>
        </button>
      </li>
      <li :class="navClassBankingData" role="presentation">
        <button
          :class="tabClass('bankingData')"
          id="bank-tab"
          data-bs-toggle="pill"
          data-bs-target="#bank"
          type="button"
          aria-controls="bank"
          aria-selected="false"
          @click.prevent="toggleTab('bankingData')"
        >
          <span v-if="isMobile == 0 || activeTab('bankingData')">{{
            transPeralbaPro.item843
          }}</span>
          <span v-else>{{ transPeralbaPro.item844 }}</span>
        </button>
      </li>
      <li :class="navClassAccessData" role="presentation">
        <button
          :class="tabClass('accessData')"
          id="access-tab"
          data-bs-toggle="pill"
          data-bs-target="#access"
          type="button"
          aria-controls="access"
          aria-selected="false"
          @click.prevent="toggleTab('accessData')"
        >
          <span v-if="isMobile == 0 || activeTab('accessData')">{{
            transPeralbaPro.item818
          }}</span>
          <span v-else>{{ transPeralbaPro.item819 }}</span>
        </button>
      </li>
    </ul>

    <div class="tab-content" id="myTabContent">
      <professional-register-fiscal-data
        :active-tab="activeTab('fiscalData')"
        v-show="tabs.fiscalData"
        :fiscal-name="form.fiscalName"
        :nif="form.nif"
        :fiscal-address="form.fiscalAddress"
        :fiscal-zipcode="form.fiscalZipcode"
        :fiscal-city="form.fiscalCity"
        :fiscal-province="form.fiscalProvince"
        :selected-number-workers="form.selectedNumberWorkers"
        :nombre-admin="form.nombreAdmin"
        :email="form.email"
        :mobile-admin="form.mobileAdmin"
        :phone-admin="form.phoneAdmin"
        :number-workers="numberWorkers"
        :disabledForm="disabledForm"
        :errors="errors"
        :trans-peralba-pro="transPeralbaPro"
        @validateRegisterFiscalData="validateRegisterFiscalData"
        @goToDatosComerciales="toggleTab('comercialData')"
        @updateField="updateField"
      />
      <professional-register-comercial-data
        :active-tab="activeTab('comercialData')"
        v-show="tabs.comercialData"
        :fiscal-address="form.fiscalAddress"
        :comercial-address="form.comercialAddress"
        :personaContacto="form.personaContacto"
        :cargo-empresa="form.cargoEmpresa"
        :nombre-comercial="form.nombreComercial"
        :emailComercial="form.emailComercial"
        :mobile-comercial="form.mobileComercial"
        :phone-comercial="form.phoneComercial"
        :selected-warehouse="form.selectedWarehouse"
        :selected-activity="form.selectedActivity"
        :activity-workers="activityWorkers"
        :selected-principal-activity="form.selectedPrincipalActivity"
        :warehouses="warehouses"
        :activity-general-workers="activityGeneralWorkers"
        :disabledForm="disabledForm"
        :errors="errors"
        :trans-peralba-pro="transPeralbaPro"
        :fiscal-name="form.fiscalName"
        :email="form.email"
        :nombre-admin="form.nombreAdmin"
        :mobile-admin="form.mobileAdmin"
        :phone-admin="form.phoneAdmin"
        @validateRegisterComercialData="validateRegisterComercialData"
        @goToDatosBancarios="toggleTab('bankingData')"
        @goToDatosFiscales="toggleTab('fiscalData')"
        @updateField="updateField"
      />
      <professional-register-banking-data
        :active-tab="activeTab('bankingData')"
        v-show="tabs.bankingData"
        :nombre-contacto-banco="form.nombreContactoBanco"
        :selected-electronic-invoicing="form.selectedElectronicInvoicing"
        :email-invoicing="form.emailInvoicing"
        :iban="form.iban"
        :nombre-banco="form.nombreBanco"
        :swift="form.swift"
        :selected-payment-method="form.selectedPaymentMethod"
        :sepa="form.sepa"
        :disabledForm="disabledForm"
        :errors="errors"
        :payment-methods="paymentMethods"
        :route-legal="routeLegal"
        :route-sepa="routeSepaWithParams"
        :trans-peralba-pro="transPeralbaPro"
        @handleDropzone="handleDropzone"
        @validateRegisterBankingData="validateRegisterBankingData"
        @goToDatosComerciales="validateRegisterFiscalData()"
        @goToDatosAcceso="toggleTab('accessData')"
        @updateField="updateField"
      />
      <professional-register-access-data
        :active-tab="activeTab('accessData')"
        v-show="tabs.accessData"
        :email="form.email"
        :password="form.password"
        :selected-lang="form.selectedLang"
        :newsletter="form.newsletter"
        :newsletter-interests="form.newsletterInterests"
        :whatsapp="form.whatsapp"
        :legal="form.legal"
        :languages="languages"
        :activities="activities"
        :route-legal="routeLegal"
        :route-privacy="routePrivacy"
        :disabledForm="disabledForm"
        :errors="errors"
        :trans-peralba-pro="transPeralbaPro"
        @crearCuenta="validateRegisterAccessData"
        @updateField="updateField"
      />
    </div>
  </div>
</template>
<script>
import HTTP from "../../../../services/http";
import validation from "../mixins/validation";
import ProfessionalRegisterFiscalData from "../components/ProfessionalRegister/ProfessionalRegisterFiscalData";
import ProfessionalRegisterComercialData from "../components/ProfessionalRegister/ProfessionalRegisterComercialData";
import ProfessionalRegisterBankingData from "../components/ProfessionalRegister/ProfessionalRegisterBankingData";
import ProfessionalRegisterAccessData from "../components/ProfessionalRegister/ProfessionalRegisterAccessData";
export default {
  components: {
    ProfessionalRegisterFiscalData,
    ProfessionalRegisterComercialData,
    ProfessionalRegisterBankingData,
    ProfessionalRegisterAccessData,
  },
  mixins: [validation],
  props: [
    "email",
    "password",
    "routePrivacy",
    "routeLegal",
    "routeSepa",
    "languages",
    "activities",
    "numberWorkers",
    "warehouses",
    "disabledForm",
    "activityGeneralWorkers",
    "activityWorkers",
    "paymentMethods",
    "routeRegister",
    "defaultSelectedLang",
    "isMobile",
    "transPeralbaPro",
  ],

  data() {
    return {
      form: {
        fiscalName: "",
        nif: "",
        fiscalAddress: "",
        fiscalZipcode: "",
        fiscalCity: "",
        fiscalProvince: "",
        fiscalCountry: "",
        selectedNumberWorkers: 1,
        nombreAdmin: "",
        mobileAdmin: "",
        phoneAdmin: "",
        nombreComercial: "",
        comercialAddress: "",
        personaContacto: "",
        cargoEmpresa: "",
        emailComercial: "",
        mobileComercial: "",
        phoneComercial: "",
        selectedWarehouse: 2,
        selectedActivity: 1,
        selectedPrincipalActivity: 1,
        nombreContactoBanco: "",
        selectedElectronicInvoicing: 0,
        iban: "",
        nombreBanco: "",
        swift: "",
        sepa: false,
        sepaFile: false,
        selectedLang: 1,
        newsletter: true,
        newsletterInterests: [],
        whatsapp: true,
        legal: false,
        emailInvoicing: "",
        selectedPaymentMethod: 1,
        email: "",
        password: "",
        professional: true,
      },
      errors: {
        fiscalData: [],
        comercialData: [],
        bankingData: [],
        accessData: [],
      },
      tabs: {
        fiscalData: true,
        comercialData: false,
        bankingData: false,
        accessData: false,
      },
      step: 1,
    };
  },
  created() {
    this.form.email = this.email;
    this.form.selectedLang = this.defaultSelectedLang;
  },
  mounted() {
    for (let activity of this.activities) {
      this.form.newsletterInterests.push(activity.id);
    }
  },

  methods: {
    handleDropzone(file) {
      this.form.sepaFile = file;
    },
    tabClass(tab) {
      let classExtraTab = this.activeTab(tab) ? "active" : "";
      return `nav-link ${classExtraTab}`;
    },
    toggleTab(tab) {
      this.tabs.fiscalData = tab == "fiscalData";
      this.tabs.comercialData = tab == "comercialData";
      this.tabs.bankingData = tab == "bankingData";
      this.tabs.accessData = tab == "accessData";
    },
    activeTab(tab) {
      return !!this.tabs[tab];
    },
    updateField(event) {
      this.form[event.field] = event.value;
    },
    validateRegisterFiscalData() {
      this.validateTextField("fiscalData", "fiscalName");
      this.validateNifField("fiscalData", "nif");
      this.validateTextField("fiscalData", "fiscalAddress");
      this.validateTextField("fiscalData", "fiscalZipcode");
      this.validateTextField("fiscalData", "fiscalCity");
      this.validateTextField("fiscalData", "fiscalProvince");
      this.validateTextField("fiscalData", "fiscalCountry");
      this.validateSelectField("fiscalData", "selectedNumberWorkers");
      this.validateTextField("fiscalData", "nombreAdmin");
      this.validateEmailField("fiscalData", "email");
      this.validatePhoneField("fiscalData", "mobileAdmin");
      this.validatePhoneField("fiscalData", "phoneAdmin", false);

      if (this.errors.fiscalData.length === 0) {
        this.step = 2;
        this.toggleTab("comercialData");
      }
    },
    validateRegisterComercialData() {
      this.validateTextField("comercialData", "nombreComercial");
      this.validateTextField("comercialData", "comercialAddress");
      this.validateTextField("comercialData", "personaContacto");
      this.validateTextField("comercialData", "cargoEmpresa");
      this.validateEmailField("comercialData", "emailComercial");
      this.validatePhoneField("comercialData", "mobileComercial");
      this.validatePhoneField("comercialData", "phoneComercial", false);
      this.validateSelectField("comercialData", "selectedWarehouse");
      this.validateSelectField("comercialData", "selectedActivity");
      this.validateSelectField("comercialData", "selectedPrincipalActivity");

      if (this.errors.comercialData.length === 0) {
        this.step = 3;
        this.toggleTab("bankingData");
      }
    },
    validateRegisterBankingData() {
      this.validateTextField("bankingData", "nombreContactoBanco");

      if (this.form.selectedElectronicInvoicing === 1) {
        this.validateEmailField("bankingData", "emailInvoicing");
      }

      this.validateRadioButtonField("bankingData", "selectedPaymentMethod");
      this.removeError("bankingData", "iban");
      this.removeError("bankingData", "nombreBanco");
      this.removeError("bankingData", "swift");
      this.removeError("bankingData", "sepa");
      if (
        this.form.selectedPaymentMethod == 2 ||
        this.form.selectedPaymentMethod == 3
      ) {
        this.validateIbanField("bankingData", "iban");
        this.validateTextField("bankingData", "nombreBanco");
        this.validateSwiftField("bankingData", "swift");
        this.validateCheckboxField("bankingData", "sepa");
      }
      if (this.errors.bankingData.length === 0) {
        this.step = 4;
        this.toggleTab("accessData");
      }
    },
    validateRegisterAccessData() {
      this.validateEmailField("accessData", "email");
      this.validateTextField("accessData", "password");
      this.validateSelectField("accessData", "selectedLang");
      this.validateCheckboxField("accessData", "legal");

      if (
        this.errors.accessData.length === 0 &&
        this.errors.bankingData.length === 0 &&
        this.errors.comercialData.length === 0 &&
        this.errors.fiscalData.length === 0
      ) {
        this.registerProfessional();
      }
    },
    async registerProfessional() {
      this.$emit("loading", true);
      try {
        let headers = {
          "Content-Type": "multipart/form-data",
          enctype: "multipart/form-data",
        };
        let formData = new FormData();
        Object.keys(this.form).forEach((key) => {
          formData.append(key, this.form[key]);
        });

        const response = await HTTP.post(
          this.routeRegister,
          this.form,
          headers
        );
        if (response.data.status == 1) {
          this.$emit("changeView", 6);
          this.$emit("showFirst", true);
        } else {
          this.errors.push(response.data);
        }
        this.$emit("loading", false);
      } catch (e) {
        this.$emit("loading", false);
      }
    },
    navClass(step) {
      let classExtraTab = this.step < step ? "disabled" : "";
      return `nav-item ${classExtraTab}`;
    },
  },
  computed: {
    routeSepaWithParams() {
      const SEPA_PARAMS = {
        selectedWarehouse: this.form.selectedWarehouse,
        fiscalName: this.form.fiscalName,
        nif: this.form.nif,
        fiscalAddress: this.form.fiscalAddress,
        fiscalZipcode: this.form.fiscalZipcode,
        fiscalCity: this.form.fiscalCity,
        fiscalProvince: this.form.fiscalProvince,
        fiscalCountry: this.form.fiscalCountry,
        adminMobile: this.form.mobileAdmin,
        adminEmail: this.form.email,
        electronicInvoicing: this.form.selectedElectronicInvoicing,
        emailInvoicing: this.form.emailInvoicing,
        accountSwift: this.form.swift,
        accountIban: this.form.iban,
        paymentMethod: this.form.selectedPaymentMethod,
      };
      const params = new URLSearchParams(SEPA_PARAMS).toString();
      return this.routeSepa + "?" + params;
    },
    navClassFiscalData() {
      return this.navClass(1);
    },
    navClassComercialData() {
      return this.navClass(2);
    },
    navClassBankingData() {
      return this.navClass(3);
    },
    navClassAccessData() {
      return this.navClass(4);
    },
  },
};
</script>
